export default defineNuxtLink({
  componentName: 'WSALink',
  // prefetchedClass: process.env.NODE_ENV === 'development'
  //   ? 'prefetched'
  //   : undefined,
  trailingSlash: 'append',
});
